import { NgModule } from "@angular/core";
import {
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatCardModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatTableModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSelectModule,
    MatRadioModule,
    MatExpansionModule,
    MatDialogModule,
    MatTooltipModule,
    MatDividerModule,
    MatSortModule,
    MatBottomSheetModule
} from '@angular/material';

@NgModule({
    imports: [
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatTableModule,
        MatAutocompleteModule,
        MatTreeModule,
        MatCheckboxModule,
        MatTabsModule,
        MatSelectModule,
        MatRadioModule,
        MatExpansionModule,
        MatDialogModule,
        MatTooltipModule,
        MatDividerModule,
        MatSortModule,
        MatBottomSheetModule
    ],
    exports: [
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatTableModule,
        MatAutocompleteModule,
        MatTreeModule,
        MatCheckboxModule,
        MatTabsModule,
        MatSelectModule,
        MatRadioModule,
        MatExpansionModule,
        MatDialogModule,
        MatTooltipModule,
        MatDividerModule,
        MatSortModule,
        MatBottomSheetModule
    ]
})
export class MaterialModule {}
